import DataTable from 'components/ui/DataTable/data-table';
import EditIcon from '../../../../assets/images/icons/edit.png';
import DeleteIcon from '../../../../assets/images/icons/delete.png';
import { FC, useState } from 'react';
import { useListServiceSubGroupQuery } from 'redux/reducers/master';

interface ITServiceSubGroupTableData {
  tableHeaders: () => React.ReactNode;
  onEditClicked: (data: any) => void;
  onDeleteClicked: (data: any) => void;
}

const ServiceSubGroupDataTable: FC<ITServiceSubGroupTableData> = ({
  tableHeaders,
  onEditClicked,
  onDeleteClicked
}) => {
  const [page, setPage] = useState(1);
  const itemsPerPage = 10;

  const { data: serviceSubGroups = [], isLoading } = useListServiceSubGroupQuery();

  const totalItems = serviceSubGroups.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const paginatedData = serviceSubGroups.slice((page - 1) * itemsPerPage, page * itemsPerPage);

  const canPrevious = page > 1;
  const canNext = page < totalPages;

  const columns = [
    {
      Header: 'Service Sub Group Name',
      accessor: 'name'
    },
    {
      Header: 'Service Group',
      accessor: 'service_group_master',
      Cell: ({ value }: any) => value?.name ?? '-'
    },
    {
      Header: 'Action',
      Cell: ({ row }: any) => (
        <>
          <img src={EditIcon} className="icons" onClick={() => onEditClicked(row.original)} />
          <img
            src={DeleteIcon}
            className="m-2 icons"
            onClick={() => onDeleteClicked(row.original)}
          />
        </>
      )
    }
  ];

  return (
    <div className="list form-check-all">
      <DataTable
        columns={columns}
        data={paginatedData}
        tableHeaders={tableHeaders}
        isLoading={isLoading}
        pagination={{
          canNext,
          canPrevious,
          prevPage: () => page > 1 && setPage(page - 1),
          nextPage: () => page < totalPages && setPage(page + 1)
        }}
      />
    </div>
  );
};

export default ServiceSubGroupDataTable;
